'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002432 from "./presto.-Agent-View$$anon$32.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024 from "./presto.-Agent-View$-Closed$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dOpened$0024 from "./presto.-Agent-View$-Opened$.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dReceive$002dProtocol$0024 from "./presto.-Agent-View$-Receive-Protocol$.js";
import * as $j_presto$002e$002dWeb$002dSockets$0024$002dClosed$0024 from "./presto.-Web-Sockets$-Closed$.js";
import * as $j_presto$002e$002dWeb$002dSockets$0024$002dError$0024 from "./presto.-Web-Sockets$-Error$.js";
import * as $j_presto$002e$002dWeb$002dSockets$0024$002dFrame from "./presto.-Web-Sockets$-Frame.js";
import * as $j_presto$002e$002dWeb$002dSockets$0024$002dOpened$0024 from "./presto.-Web-Sockets$-Opened$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$31(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_AgentView$$anon$31 as $c_Lpresto_AgentView$$anon$31 };
$p = $c_Lpresto_AgentView$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$31;
/** @constructor */
function $h_Lpresto_AgentView$$anon$31() {
}
export { $h_Lpresto_AgentView$$anon$31 as $h_Lpresto_AgentView$$anon$31 };
$h_Lpresto_AgentView$$anon$31.prototype = $p;
$p.cDO = (function(msg) {
  try {
    var this$6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002432.$c_Lpresto_AgentView$$anon$32(), msg);
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Printer$().a6a.vn(this$6));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cCQ = (function(msg) {
  if (($j_presto$002e$002dWeb$002dSockets$0024$002dOpened$0024.$m_Lpresto_WebSockets$Opened$() === msg)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_presto$002e$002dAgent$002dView$0024$002dOpened$0024.$m_Lpresto_AgentView$Opened$());
  }
  if (($j_presto$002e$002dWeb$002dSockets$0024$002dClosed$0024.$m_Lpresto_WebSockets$Closed$() === msg)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_presto$002e$002dAgent$002dView$0024$002dClosed$0024.$m_Lpresto_AgentView$Closed$());
  }
  if (($j_presto$002e$002dWeb$002dSockets$0024$002dError$0024.$m_Lpresto_WebSockets$Error$() === msg)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$());
  }
  if ((msg instanceof $j_presto$002e$002dWeb$002dSockets$0024$002dFrame.$c_Lpresto_WebSockets$Frame)) {
    var x114 = msg.Kl;
    return $j_presto$002e$002dAgent$002dView$0024$002dReceive$002dProtocol$0024.$m_Lpresto_AgentView$ReceiveProtocol$().cCS(x114);
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(msg);
});
var $d_Lpresto_AgentView$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$31, "presto.AgentView$$anon$31", ({
  DV: 1,
  Vc: 1
}));
export { $d_Lpresto_AgentView$$anon$31 as $d_Lpresto_AgentView$$anon$31 };
//# sourceMappingURL=presto.-Agent-View$$anon$31.js.map
